export const tableConfig = {
  pagination: false,
};
